import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  InputAdornment,
} from "@mui/material";

import React, { useState } from "react";
import { connect } from "react-redux";
import { reviewTrainingRequest } from "../../../store/training/actions";
import { showError } from "../../../app/toastify";
import { Editor } from "../../common/components/Utils";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import AuthorizationPermit from "./AuthorizationPermit";
import ErrorMessage from "../../common/components/ErrorMessage";
const ReviewTrainingRequestDialog = (props) => {
  const {
    loading,
    level,
    showReviewRequest,
    setShowReviewRequest,
    setShowTrainingRequestDetails,
    request,
    reviewTrainingRequest,
  } = props;

  const [formData, setFormData] = useState({
    referenceNo: request.referenceNo,
    level: level,
    comments: ``,
    coveredRelatedCostsDetails: request.coveredRelatedCostsDetails,
    draftAuthorizationPermitContent: request.draftAuthorizationPermitContent,
    draftAuthorizationLetterContent: request.draftAuthorizationLetterContent,
  });
  const [errors, setErrors] = useState({
    commentHasError: false,
  });

  const formValidator = () => {
    const error = {
      commentHasError: false,
      hasError: false,
    };

    if (!formData.comments) {
      error.commentHasError = true;
      error.hasError = true;
    }

    setErrors(error);

    if (error.hasError) {
      showError("Please fill out all required fields");
      return true;
    }
    return false;
  };

  const onSave = () => {
    if (!formValidator()) {
      reviewTrainingRequest(formData, setShowTrainingRequestDetails, onClose);
    }
  };

  const onClose = () => {
    setFormData({
      referenceNo: "",
      level: "",
      comments: ``,
    });
    setShowReviewRequest(false);
  };

  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showReviewRequest}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle className="text-primary">
          <Typography variant="overline" display="block">
            REQUEST {level.toUpperCase()} REVIEW
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
        </DialogTitle>

        <DialogContent dividers style={{ height: "30vh" }}>
          <div className="col-12">
            <div className="col-12 mt-0">
              <ReactQuill
                theme="snow"
                placeholder="Type your comments..."
                value={formData.comments || ""}
                modules={Editor.modules}
                formats={Editor.formats}
                onChange={(value) => {
                  const comments = value;
                  setFormData({
                    ...formData,
                    comments,
                  });
                  const commentHasError = false;
                  setErrors({ ...errors, commentHasError });
                }}
              />
              <ErrorMessage
                hasError={errors.commentHasError}
                message="A comment is needed."
              />
            </div>
          </div>
        </DialogContent>

        <DialogActions className="d-flex justify-content-center">
          <div className="p-3">
            <div className="row">
              <div className="col-12 mt-1">
                <button
                  onClick={onSave}
                  type="button"
                  className="btn btn-primary text-uppercase  px-4 float-right"
                  disabled={loading}
                >
                  {loading ? "Wait..." : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
};

const mapStateToProps = ({ loading, user }) => {
  return {
    loading,
    user,
  };
};
export default connect(mapStateToProps, {
  reviewTrainingRequest,
})(ReviewTrainingRequestDialog);
